import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { PartnersAutocomplete } from "@shared/components/AutocompleteFields";

export const ReferralListFilters = React.memo(() => {
  const translate = useTranslate();

  const statusOptions = [
    { value: "pending", label: translate("partners.status.pending") },
    { value: "approved", label: translate("partners.status.approved") },
    { value: "rejected", label: translate("partners.status.rejected") },
  ];

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="search"
          label={translate("v1/partner_referral_admin.filters.search")}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="status"
          label={translate("v1/partner_referral_admin.fields.status")}
          options={statusOptions}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <PartnersAutocomplete
          name="partner"
          label={translate("v1/partner_referral_admin.fields.partner")}
        />
      </Grid>
    </Grid>
  );
});
